export default function focusMe($timeout) {
  return {
    link: function (scope, element, attrs) {
      $timeout(function () {
        element[0].focus();
      }, attrs.focusMe || 250);

      var unsub = scope.$on('focus-me', function () {
        $timeout(function () {
          //only focus the visible element
          if (element[0].offsetWidth > 0 && element[0].offsetHeight > 0) {
            element[0].focus();
          }
        }, 200);
      });

      scope.$on('$destroy', function () {
        unsub();
      });
    }
  };
}
